var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", [
    _c(
      "div",
      { staticClass: "row text-center pt-3 pt-xl-5" },
      [
        _c(
          "div",
          { staticClass: "col-12 col-sm-10 m-auto m-md-0 col-md-6" },
          [
            _c("p", { staticClass: "h2" }, [_c("em", [_vm._v("Box 1")])]),
            _vm._v(" "),
            _c("v-date-picker", {
              attrs: {
                mode: "range",
                "is-inline": "",
                columns: _vm.$screens({ default: 1, lg: 2 }),
                rows: _vm.$screens({ default: 1, lg: 1 }),
                "is-expanded": _vm.$screens({ default: true, lg: false }),
                attributes: _vm.attributesBox1,
                "disabled-dates": _vm.bookingsBox1,
                "min-date": new Date(),
                "first-day-of-week": 2,
                locale: _vm.locale
              },
              model: {
                value: _vm.selectedDates1,
                callback: function($$v) {
                  _vm.selectedDates1 = $$v
                },
                expression: "selectedDates1"
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "h3 mt-5" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !_vm.selectedDates1 },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$refs.book.show(1, _vm.selectedDates1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.translate("BookNow")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-sm-10 m-auto m-md-0 col-md-6 pt-5 pt-md-0"
          },
          [
            _c("p", { staticClass: "h2" }, [_c("em", [_vm._v("Box 2")])]),
            _vm._v(" "),
            _c("v-date-picker", {
              attrs: {
                mode: "range",
                "is-inline": "",
                columns: _vm.$screens({ default: 1, lg: 2 }),
                rows: _vm.$screens({ default: 1, lg: 1 }),
                "is-expanded": _vm.$screens({ default: true, lg: false }),
                attributes: _vm.attributesBox2,
                "disabled-dates": _vm.bookingsBox2,
                "min-date": new Date(),
                "first-day-of-week": 2,
                locale: _vm.locale
              },
              model: {
                value: _vm.selectedDates2,
                callback: function($$v) {
                  _vm.selectedDates2 = $$v
                },
                expression: "selectedDates2"
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "h3 mt-5" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !_vm.selectedDates2 },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$refs.book.show(2, _vm.selectedDates2)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.translate("BookNow")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("book", {
          ref: "book",
          attrs: { products: _vm.products },
          on: { close: _vm.bookClose }
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "span",
            {
              staticStyle: { "background-color": "#FEFCBF", color: "#744210" }
            },
            [_vm._v("    ")]
          ),
          _vm._v(
            " : " +
              _vm._s(_vm.translate("CalendarLegendYellow")) +
              "\n            "
          ),
          _c(
            "span",
            {
              staticStyle: { "background-color": "#FED7D7", color: "#744210" }
            },
            [_vm._v("    ")]
          ),
          _vm._v(
            " : " + _vm._s(_vm.translate("CalendarLegendRed")) + "\n        "
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"esModule":true,"extractCSS":false}!./node_modules/vue-loader/lib?{"esModule":true,"extractCSS":false}!./ClientApp/calendar/app.vue?vue&type=template&id=ea805cd2&scoped=true&
// module id = 328
// module chunks = 2